import { getInvoices } from "@iewccouk/Services/InvoiceService";
import { replaceInChain } from "@insite/client-framework/HandlerCreator";
import { chain, RequestDataFromApi } from "@insite/client-framework/Store/Data/Invoices/Handlers/LoadInvoices";

replaceInChain(chain, RequestDataFromApi, async props => {
    try {
        props.apiResult = await getInvoices(props.apiParameter);
    } catch (error) {
        if ("status" in error && error.status === 404) {
            props.dispatch({ type: "Data/Invoices/FailedToLoadInvoices" });
            return false;
        }

        throw error;
    }
});
